import React from "react";
import { Link } from "wouter";

export function FoNavInstrumentName({
    name,
    instrumentId
}: {
    name: React.ReactNode;
    instrumentId?: string | null;
}): React.ReactElement {
    if (!instrumentId) {
        return <>{name}</>;
    }
    return <Link to={`/instruments/${instrumentId}`}>{name}</Link>;
}

export function formatFoNavInstrumentName(
    value: string,
    item?: { instrumentId?: string | null }
): React.ReactElement {
    return <FoNavInstrumentName name={value} instrumentId={item?.instrumentId} />;
}
